import { gql } from '@apollo/client'

export const GET_ALLOWED_TARGETS = gql`
  query {
    allowedTargets {
      id
      name
    }
  }
`
